import { parametersSlice } from "./parametersSlice";
import * as defaultActions from "../../../../../redux/_common";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";
import { constructInitialFilters } from "../../../../components/common/filters/utils";
import { getErrorMessage } from "../../../../../redux/_helpers";

const { actions } = parametersSlice;
const moduleUrl = '/api/settings/parameters'

export const setValidationErrors = actions.setValidationErrors;

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id
  );

export const getFilters = () => async (dispatch:Dispatch) => {
    try {
        const relevanceFilters:any[] = await get(`${moduleUrl}/complexSearchRelevance`);
        const stateFilters:any[] = await get(`${moduleUrl}/complexSearchState`);
        dispatch(actions.setFilter(
            constructInitialFilters([
                ...(relevanceFilters || []),
                ...(stateFilters || []),
            ])
        ));
  
    } catch (errors) {
        const message = getErrorMessage(errors, "Error occurred!");
        dispatch(actions.catchError({ message, callType: "parametersLoading", errorProp: "errorParameter" }));
    }
}

export const setFilter = (filters: any[]) => defaultActions.setFilters(filters, actions);

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
